<div class="header-button-user-config">
  <p-menu #menu [model]="menuItems" [popup]="true" [showTransitionOptions]="'150ms'" [hideTransitionOptions]="'150ms'" appendTo="body"></p-menu>
  <button pButton type="button" icon="pi pi-user" class="sling-button-local" (click)="menu.toggle($event)" [pTooltip]="'MY-ACCOUNT' | translate"></button>
</div>
